// extracted by mini-css-extract-plugin
var _1 = "ProfileAISummaryWidgetHeaderContentTitle-moduleProfileAISummaryWidgetHeaderContentTitle__ZjFMw";
var _2 = "ProfileAISummaryWidgetHeaderContentTitle-moduletitle__sVwx8 WidgetHeaderContentTitle-moduleWidgetHeaderContentTitle__DV1nU";
export { _1 as "ProfileAISummaryWidgetHeaderContentTitle", _2 as "title" }
